// extracted by mini-css-extract-plugin
module.exports = {"banner_description":"banner_description__3dt4E"};